export const validateCloudbizImportFile = (keys: string[]) => {
    let result = "";

    if (!keys.includes("名称")) {
        result += "\r\nフィールド「名称」が不足しています。";
    }
    if (!keys.includes("名称カナ")) {
        result += "\r\nフィールド「名称カナ」が不足しています。";
    }
    if (!keys.includes("内線/外線")) {
        result += "\r\nフィールド「内線/外線」が不足しています。";
    }
    if (!keys.includes("電話番号")) {
        result += "\r\nフィールド「電話番号」が不足しています。";
    }

    return result;
};
